import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { Product } from '../../interfaces/Product/Product';
import { ProductOptionValue } from '../../interfaces/Product/ProductOption';
import { sharedColors } from '../../utils/Style';
import { useLocalizedText } from '../../hooks/useLocalizedText';

type ProductNotesProps = {
  product: Product;
  option?: ProductOptionValue;
};

export const ProductNotes = ({ product, option }: ProductNotesProps) => {
  const t = useLocalizedText();

  const keyStyles = {
    fontSize: '14px',
    color: sharedColors.gray4,
  };

  const valueStyles = {
    fontSize: '14px',
    color: sharedColors.gray6,
    fontWeight: 600,
  };

  const resolvedSkt = option?.skt ?? product.skt;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Typography sx={keyStyles}>
        {t('product.brand')}:{' '}
        <Link
          to={`/marka/${product.brand.slug}`}
          style={{ textDecoration: 'none' }}
        >
          <Typography component='span' sx={valueStyles}>
            {product.brand.name}
          </Typography>
        </Link>
      </Typography>

      {!!resolvedSkt && (
        <Typography sx={keyStyles}>
          {t('product.expiration_date')}:{' '}
          <Typography component='span' sx={valueStyles}>
            {resolvedSkt}
          </Typography>
        </Typography>
      )}

      <Typography sx={keyStyles}>
        {t('product.sku')}:{' '}
        <Typography
          component='span'
          sx={{ fontSize: '14px', color: sharedColors.gray4 }}
        >
          {product.sku}
        </Typography>
      </Typography>
    </Box>
  );
};
